(() => {
  /* One message at a time, as on icon-amsterdam.com: a 300 ms cross-fade every
     5 s, and arrows to step by hand. Reduced motion: no auto-advance. */
  const DELAY = 5000;
  const REDUCED = window.matchMedia("(prefers-reduced-motion: reduce)");
  const HOVER = window.matchMedia("(hover: hover)");

  const setup = (bar) => {
    if (bar.dataset.rotateBound) return;
    const slides = Array.from(bar.querySelectorAll("[data-rotate-slide]"));
    if (slides.length < 2) return;
    bar.dataset.rotateBound = "true";

    const prev = bar.querySelector("[data-rotate-prev]");
    const next = bar.querySelector("[data-rotate-next]");
    let index = Math.max(0, slides.findIndex((slide) => slide.classList.contains("is-active")));
    let timer = null;
    let held = false;

    const show = (to) => {
      index = (to + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle("is-active", i === index));
    };

    const stop = () => {
      clearInterval(timer);
      timer = null;
    };
    const start = () => {
      stop();
      if (!REDUCED.matches && !held) timer = setInterval(() => show(index + 1), DELAY);
    };

    /* Stepping by hand restarts the 5 s, so the chosen message stays its full time. */
    prev.addEventListener("click", () => { show(index - 1); start(); });
    next.addEventListener("click", () => { show(index + 1); start(); });

    /* Hold still while a mouse or keyboard focus is on the bar (WCAG 2.2.2).
       Mouse only: a tap on a phone counts as entering and never leaves. */
    const hold = (on) => { held = on; start(); };
    bar.addEventListener("pointerenter", (event) => { if (HOVER.matches && event.pointerType === "mouse") hold(true); });
    bar.addEventListener("pointerleave", (event) => { if (HOVER.matches && event.pointerType === "mouse") hold(false); });
    bar.addEventListener("focusin", (event) => { if (event.target.matches(":focus-visible")) hold(true); });
    bar.addEventListener("focusout", (event) => { if (!bar.contains(event.relatedTarget)) hold(false); });

    REDUCED.addEventListener("change", start);

    /* Theme editor: selecting a message block shows it. */
    document.addEventListener("shopify:block:select", (event) => {
      const i = slides.indexOf(event.target);
      if (i > -1) { show(i); stop(); }
    });
    document.addEventListener("shopify:block:deselect", start);

    prev.hidden = false;
    next.hidden = false;
    start();
  };

  const init = (root) => {
    (root || document).querySelectorAll("[data-rotate]").forEach(setup);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init());
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", (event) => init(event.target));
})();
